import {
    createColumnDate,
    createColumnInput,
    createColumnInputNumber
} from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { createButtonCreate } from "../../../../../utils/button";
import { onClickDeleteAllClient } from '../../../../../utils/form';
import { createLoading } from '../../../../../utils/loading';
import { has } from "../../../../../utils/menu-context";
import { createManageDelete, createPage } from '../../../../../utils/page';
import lodash from 'lodash'
import { openModalList } from "./haz-license-storage-location.table";
import { openModalListMenufacture } from "./haz-license-storage-location.table";
import moment from "moment";
import { formatInputValue } from "../../../../../components/input/template-builder/input-number/input-number.logic";

export const { isLoading, setIsLoading } = createLoading()

export const createColumns = ({ props }) => {
    const { isLocation } = props
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.storageLocation.name"), dataIndex: "refStorageLocation.name",  align: "center", visible: () => isLocation === true }),
        createColumnInput({ title: () => i18n.global.t("views.request.manufactureLocation.name"), dataIndex: "refStorageLocation.name",  align: "center", visible: () => isLocation === false }),
        createColumnInput({ title: () => i18n.global.t("model.address.modelName"), dataIndex: "refStorageLocation.addresses.0.addrTh",  align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.storageLocation.approveCode"), dataIndex: "refStorageLocation.approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.storageLocation.expireDate"), dataIndex: "refStorageLocation.expireDate", align: "center" }),
        createColumnInputNumber({ title: () => i18n.global.t("model.storageLocation.productionArea"), dataIndex: "refStorageLocation.productionArea", align: "center", visible: () => isLocation === false, }),
        createColumnInput({
            title: () => i18n.global.t("model.storageLocationSub.totalCapacity"),
            visible: () => isLocation === true,
            dataIndexValue: ({ record }) => {
                let totalCapacity = 0
                record.refStorageLocation.subs.forEach(items => {
                    totalCapacity += items.totalCapacity
                })
                return formatInputValue({ props: { comma: true, allowPrecision: true, maxPrecision: 2, value: totalCapacity }, data: { focus: false } })
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.storageLocationSub.useCapacity"),
            visible: () => isLocation === true,
            dataIndexValue: ({ record }) => {
                let useCapacity = 0
                record.refStorageLocation.subs.forEach(items => {
                    useCapacity += items.useCapacity
                })
                return formatInputValue({ props: { comma: true, allowPrecision: true, maxPrecision: 2, value: useCapacity }, data: { focus: false } })
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.storageLocationSub.useKg"),
            visible: () => isLocation === true,
            dataIndexValue: ({ record }) => {
                let useKg = 0
                record.refStorageLocation.subs.forEach(items => {
                    useKg += items.useKg
                })

                return formatInputValue({ props: { comma: true, allowPrecision: true, maxPrecision: 2, value: useKg }, data: { focus: false } })
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
    ]
    return columns
}

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, visible, dataTempKey, isLocation } = props
    const { useForm } = data
    const { modelRef } = useForm
    let dataModelRef = modelRef[dataTempKey]
    const items = itemsKey ? lodash.get(dataModelRef, itemsKey) : dataModelRef

    data.columns = createColumns({ props })
    data.page = createPage({ data: items })
    data.tableOptions = { search: { activeKey: null } }
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => viewOnly || [ "3", "4" ].includes(modelRef.refRequestType?.key) && [ undefined, "draft" ].includes(modelRef.refStatus?.key) ? false : has({ menuContext, key: 'canDelete' }),
            onClick: ({ rowSelection }) => onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey })
        }),
    ]
    data.manageExtras = []
    data.rowActions = []
    if (!viewOnly) {
        if (visible) {
            if(isLocation) {
                data.manageExtras.push({
                    render: () => ({
                        ...createButtonCreate({
                            onClick: () => openModalList({
                                onIframeMounted: ({ refs, options }) => {
                                    onIFrameClickSelectAll({
                                        refs,
                                        options,
                                        items,
                                        itemKey: 'refStorageLocation.id',
                                        rowKey: 'id',
                                        setKey: 'refStorageLocation',
                                        isLocation,
                                        userCompanyId: dataModelRef.refUserCompany.id,
                                        afterSelect: () => {
                                            dataModelRef.specificArea = sumUserArea({ items })
                                        }
                                    })
                                },
                            }),
                            options: { text: i18n.global.t('model.storageLocation.isLocation') }
                        }),
                    }),
                    visible: () => has({ menuContext, key: 'canCreate' }) && [ undefined, "draft" ].includes(modelRef.refStatus?.key) && ![ "3", "4" ].includes(modelRef.refRequestType?.key) && dataModelRef.refUserCompany,
                })
            } else {
                data.manageExtras.push({
                    render: () => ({
                        ...createButtonCreate({
                            onClick: () => openModalListMenufacture({
                                onIframeMounted: ({ refs, options }) => {
                                    onIFrameClickSelectAll({
                                        refs,
                                        options,
                                        items,
                                        itemKey: 'refStorageLocation.id',
                                        rowKey: 'id',
                                        setKey: 'refStorageLocation',
                                        isLocation,
                                        userCompanyId: dataModelRef.refUserCompany.id,
                                    })
                                },
                            }),
                            options: { text: i18n.global.t('views.request.manufactureLocation.desc') }
                        }),
                    }),
                    visible: () => has({ menuContext, key: 'canCreate' }) && [ undefined, "draft" ].includes(modelRef.refStatus?.key) && ![ "3", "4" ].includes(modelRef.refRequestType?.key) && dataModelRef.refUserCompany,
                })
            }
        }
    }
}

export const onIFrameClickSelectAll = ({ refs, options, items, itemKey, getKey, rowKey, setKey, onSearch, afterSelect, isLocation, userCompanyId }) => {
    refs.iframe.contentWindow.onSearch = (param) => {
        const page = param?.page;
        const defaultOnSearch = () => {
            const value = items.filter((d) => d.isDelete !== true).map((d) => lodash.get(d, itemKey));
            if (value.length > 0) {
                page.where.push({ name: rowKey, type: "UUID", operator: "!in", value });
            }
            page.where.push({ name: "isLocation", type: "Boolean", operator: "=", value: isLocation });
            page.where.push({ name: "effectiveDate", type: "Date", operator: "<=", value: moment().format("YYYY-MM-DD") });
            page.where.push({ name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") });
            page.where.push({ name: "isTemp", type: "Boolean", operator: "=", value: false });
            page.where.push({ name: "isActive", type: "Boolean", operator: "=", value: true });
            page.where.push({ name: "refStatus.key", type: "String", operator: "=", value: "complete" });
            page.where.push({ name: "refUserCompany.id", type: "UUID", operator: "=", value: userCompanyId });
        };
        if (onSearch) {
            onSearch(param);
        } else {
            defaultOnSearch();
        }
    };
    refs.iframe.contentWindow.onSelect = ({ rowSelection }) => {
        const itemsPush = [];
        rowSelection.selectedRows.forEach((row) => {
            const rowGet = getKey ? lodash.get(row, getKey) : row;
            let item = items.find((d) => lodash.get(d, itemKey) === lodash.get(row, rowKey));
            if (item) {
                item.isActive = true;
                item.isDelete = false;
                lodash.set(item, setKey, rowGet);
            } else {
                item = { isSave: true };
                if (setKey) {
                    lodash.set(item, setKey, rowGet);
                } else {
                    lodash.assign(item, rowGet);
                }
                itemsPush.push(item);
            }
        });
        items.push(...itemsPush);
        afterSelect?.({ rowSelection });
        options.bind.onCancel();
    };
};

export const sumUserArea = ({ items }) => {
    const subs = items.filter(d=>!d.isDelete).flatMap(d=>d.refStorageLocation?.subs);
    const uniqSubs = lodash.uniqBy(subs, "id");
    const useAreas = uniqSubs.map(d=>d.useArea || 0);
    return lodash.sum(useAreas);
};
